import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Snowflake = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 2v20m2.678-17.857A5.3 5.3 0 0 1 12 4.857a5.3 5.3 0 0 1-2.678-.714m0 15.714A5.36 5.36 0 0 1 12 19.143c.943 0 1.87.247 2.678.714M21 7 3 17m17.41-6.696a5.1 5.1 0 0 1-1.982-1.875 4.86 4.86 0 0 1-.695-2.59M3.59 13.696a5.1 5.1 0 0 1 1.982 1.875c.472.787.712 1.682.696 2.59M3 7l18 10M3.59 10.304a5.1 5.1 0 0 0 1.982-1.875 4.86 4.86 0 0 0 .696-2.59m14.142 7.857a5.1 5.1 0 0 0-1.982 1.875 4.86 4.86 0 0 0-.695 2.59"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Snowflake) as SvgIcon;
export { ForwardRef as ReactComponent };
